import { create } from "zustand";
import { useAuthenticated, TPinnedPromptRevision } from "@/zapi-frontend/shared/hooks/useAuthenticated";
import { TAccessMode } from "@libs/shared-permissions";

// Tech debt: update typing here
type Me = Partial<ReturnType<typeof useAuthenticated>["me"]> & {
  firstName: string;
  lastName: string;
  role?: string;
  accessMode?: TAccessMode;
  organizationId?: number;
  organizationName?: string | null;
};

type MeState = Me & {
  isLabs?: boolean;
  customSnippetsUrl: string | null;
  pinnedPromptRevisions: TPinnedPromptRevision[];
  refetch?: () => Promise<void>;
  setMe: (data: Partial<Omit<MeState, "setMe">>) => void;
};

export const useMeStore = create<MeState>((set) => ({
  firstName: "",
  lastName: "",
  customSnippetsUrl: null,
  pinnedPromptRevisions: [],
  refetch: undefined,
  setMe: (data) => set((state) => ({ ...state, ...data }))
}));
